const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCacaFigurinhasLogoV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 528.83",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Logo Ca\xE7a Figurinhas") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Canarinho pistola flat icon estilizado nas cores do Brasil, segurando um \xE1lbum de figurinhas"), /*#__PURE__*/React.createElement("path", {
    d: "M340 18 C340 18 560 68 560 68 L560 260 Q560 420 340 478 Q120 420 120 260 L120 68 Z",
    fill: "#006437",
    style: {
      fill: "rgb(0, 100, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 42 C340 42 536 86 536 86 L536 260 Q536 396 340 450 Q144 396 144 260 L144 86 Z",
    fill: "#FFDF00",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 62 C340 62 516 102 516 102 L516 260 Q516 376 340 428 Q164 376 164 260 L164 102 Z",
    fill: "#003087",
    style: {
      fill: "rgb(0, 48, 135)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 80 C340 80 498 116 498 116 L498 260 Q498 358 340 408 Q182 358 182 260 L182 116 Z",
    fill: "#006437",
    style: {
      fill: "rgb(0, 100, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 290,
    rx: 88,
    ry: 98,
    fill: "#FFD600",
    style: {
      fill: "rgb(255, 214, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 308,
    rx: 54,
    ry: 66,
    fill: "#FFFDE7",
    style: {
      fill: "rgb(255, 253, 231)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 252 Q340 238 380 252",
    stroke: "#F9A825",
    strokeWidth: 2,
    fill: "none",
    style: {
      fill: "none",
      stroke: "rgb(249, 168, 37)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 260 Q210 238 196 272 Q186 300 210 318 Q232 330 258 308 Q252 285 256 268 Z",
    fill: "#F9A825",
    style: {
      fill: "rgb(249, 168, 37)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 278 Q198 292 202 308",
    stroke: "#E65100",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(230, 81, 0)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 270 Q206 284 208 300",
    stroke: "#E65100",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(230, 81, 0)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 258 Q468 240 484 270 Q492 295 472 314 Q452 326 428 308 Q428 283 428 265 Z",
    fill: "#F9A825",
    style: {
      fill: "rgb(249, 168, 37)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 278 Q482 292 478 308",
    stroke: "#E65100",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(230, 81, 0)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 270 Q474 284 472 300",
    stroke: "#E65100",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(230, 81, 0)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 228,
    width: 52,
    height: 68,
    rx: 5,
    fill: "#003087",
    style: {
      fill: "rgb(0, 48, 135)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 233,
    width: 43,
    height: 58,
    rx: 3,
    fill: "#F0F4FF",
    style: {
      fill: "rgb(240, 244, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 228,
    width: 9,
    height: 68,
    rx: 3,
    fill: "#001A4D",
    style: {
      fill: "rgb(0, 26, 77)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 240,
    width: 13,
    height: 10,
    rx: 2,
    fill: "#FFDF00",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 240,
    width: 13,
    height: 10,
    rx: 2,
    fill: "#4CAF50",
    style: {
      fill: "rgb(76, 175, 80)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 254,
    width: 13,
    height: 10,
    rx: 2,
    fill: "#F44336",
    style: {
      fill: "rgb(244, 67, 54)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 254,
    width: 13,
    height: 10,
    rx: 2,
    fill: "#FFDF00",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 268,
    width: 29,
    height: 10,
    rx: 2,
    fill: "#E3E8F0",
    style: {
      fill: "rgb(227, 232, 240)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 291,
    fontSize: 13,
    textAnchor: "middle",
    fill: "#FFDF00",
    fontFamily: "serif",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "serif",
      fontSize: 13,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "\u2605"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 196,
    rx: 66,
    ry: 62,
    fill: "#FFD600",
    style: {
      fill: "rgb(255, 214, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 152,
    rx: 60,
    ry: 18,
    fill: "#006437",
    style: {
      fill: "rgb(0, 100, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 152 Q286 118 340 110 Q394 118 395 152 Z",
    fill: "#006437",
    style: {
      fill: "rgb(0, 100, 55)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 153,
    rx: 64,
    ry: 10,
    fill: "#005530",
    style: {
      fill: "rgb(0, 85, 48)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 152 Q286 143 340 140 Q394 143 395 152",
    stroke: "#FFDF00",
    strokeWidth: 3,
    fill: "none",
    style: {
      fill: "none",
      stroke: "rgb(255, 223, 0)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 112,
    r: 9,
    fill: "#FFDF00",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 112,
    r: 5,
    fill: "#F9A825",
    style: {
      fill: "rgb(249, 168, 37)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 178 L322 171",
    stroke: "#1A1A1A",
    strokeWidth: 4,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 26, 26)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 190,
    r: 12,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 190,
    r: 7.5,
    fill: "#1A1A1A",
    style: {
      fill: "rgb(26, 26, 26)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 187,
    r: 2.5,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 171 L382 178",
    stroke: "#1A1A1A",
    strokeWidth: 4,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 26, 26)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 190,
    r: 12,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 190,
    r: 7.5,
    fill: "#1A1A1A",
    style: {
      fill: "rgb(26, 26, 26)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 187,
    r: 2.5,
    fill: "white",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 208 Q340 200 358 208 Q354 222 340 228 Q326 222 322 208 Z",
    fill: "#FF8F00",
    style: {
      fill: "rgb(255, 143, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 218 Q340 228 354 218 Q348 234 340 238 Q332 234 326 218 Z",
    fill: "#E65100",
    style: {
      fill: "rgb(230, 81, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 208 Q340 214 358 208",
    stroke: "#BF360C",
    strokeWidth: 1.5,
    fill: "none",
    style: {
      fill: "none",
      stroke: "rgb(191, 54, 12)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296,
    cy: 204,
    rx: 11,
    ry: 7,
    fill: "#FF8A65",
    opacity: 0.45,
    style: {
      fill: "rgb(255, 138, 101)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 384,
    cy: 204,
    rx: 11,
    ry: 7,
    fill: "#FF8A65",
    opacity: 0.45,
    style: {
      fill: "rgb(255, 138, 101)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 376,
    width: 16,
    height: 30,
    rx: 5,
    fill: "#FF8F00",
    style: {
      fill: "rgb(255, 143, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 376,
    width: 16,
    height: 30,
    rx: 5,
    fill: "#FF8F00",
    style: {
      fill: "rgb(255, 143, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 406 Q316 400 332 404 L330 412 Q316 416 306 412 Z",
    fill: "#E65100",
    style: {
      fill: "rgb(230, 81, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 404 Q356 400 364 406 L362 412 Q350 416 338 412 Z",
    fill: "#E65100",
    style: {
      fill: "rgb(230, 81, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 180,
    fontSize: 22,
    fill: "#FFDF00",
    opacity: 0.6,
    fontFamily: "serif",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "serif",
      fontSize: 22,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 168,
    fontSize: 16,
    fill: "#FFDF00",
    opacity: 0.55,
    fontFamily: "serif",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "serif",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 350,
    fontSize: 13,
    fill: "#FFDF00",
    opacity: 0.4,
    fontFamily: "serif",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "serif",
      fontSize: 13,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 360,
    fontSize: 13,
    fill: "#FFDF00",
    opacity: 0.4,
    fontFamily: "serif",
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "serif",
      fontSize: 13,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 498,
    fontFamily: "'Bebas Neue', Impact, sans-serif",
    fontSize: 38,
    textAnchor: "middle",
    fill: "#FFDF00",
    letterSpacing: 4,
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 38,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "CA\xC7A FIGURINHAS"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 516,
    fontFamily: "'Bebas Neue', Impact, sans-serif",
    fontSize: 14,
    textAnchor: "middle",
    fill: "#FFDF00",
    letterSpacing: 3,
    opacity: 0.75,
    style: {
      fill: "rgb(255, 223, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.75,
      fontFamily: "&quot",
      fontSize: 14,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "COPA DO MUNDO 2026"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacaFigurinhasLogoV2);
export default __webpack_public_path__ + "static/media/caca_figurinhas_logo_v2.8579fb08d59596dd881edbc2f59d8bdc.svg";
export { ForwardRef as ReactComponent };